import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { getDefaultDateRangeWithMinRetentionDate } from 'automation-ui-canvas/containers/enrollment-history/utils/dateFilterTransformers';
import DateRangeFilter from 'automation-ui-management/components/filters/DateRangeFilter';
import { getMinActionLogsRetentionSimpleDate } from 'automation-ui-management/constants/DataRetention';
import { ALL_PRESET_ID, CUSTOM_PRESET_ID } from 'automation-ui-management/constants/DateRangePickerOptions';
import { useApplicationHistoryFilters } from 'automation-ui-management/hooks/filterHooks';
import { getHistoryFiltersFromDateRange, makeDateRangeFromFilters } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { toSimpleDate } from 'automation-ui-management/utils/dateRangeUtils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const DateFilterSection = () => {
  const {
    filters,
    updateFilters
  } = useApplicationHistoryFilters();
  const dateRange = makeDateRangeFromFilters(filters);
  const today = toSimpleDate();
  const defaultStartDate = getMinActionLogsRetentionSimpleDate();
  useEffect(() => {
    if (dateRange.presetId === ALL_PRESET_ID) {
      updateFilters(getDefaultDateRangeWithMinRetentionDate(dateRange));
    }
  }, [dateRange, updateFilters]);
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentHistory.panel.enrollment-list.filter.dateRangeLabel"
    }),
    className: "m-bottom-2",
    children: /*#__PURE__*/_jsx(DateRangeFilter, {
      dateRange: dateRange,
      max: today,
      onFilterChange: currentFilter => {
        const updatedHistoryFilter = currentFilter.rangeType === ALL_PRESET_ID ? getHistoryFiltersFromDateRange({
          presetId: CUSTOM_PRESET_ID,
          startDate: defaultStartDate
        }) : currentFilter;
        updateFilters(updatedHistoryFilter);
      },
      shouldRenderFullComponent: true,
      trackingKey: Trackables.PERFORMANCE_HISTORY_FILTERS_DATE_RANGE,
      clearLabel: I18n.text('automation.enrollmentHistory.panel.enrollment-list.filter.resetDateRange'),
      use: 'on-dark'
    })
  });
};
export default DateFilterSection;